import styled from 'styled-components';

const LinkWrapper = styled.span`
  display: inline-flex;
`;

export const Styled = {
  LinkWrapper,
};
